module.exports = __webpack_public_path__ + "static/design-thinking-process-83ae534281196dc955182c01b1ce27a1.webm";